var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90168 0C4.44143 0 0 4.44019 0 9.90168C0 16.7656 8.93767 25.7817 9.31755 26.1641C9.47946 26.3248 9.68995 26.4045 9.90168 26.4045C10.1134 26.4045 10.3239 26.3235 10.4858 26.1641C10.8657 25.783 19.8034 16.7656 19.8034 9.90168C19.8034 4.44019 15.3619 0 9.90168 0ZM9.90168 24.3855C7.93131 22.2769 1.65028 15.144 1.65028 9.90044C1.65028 5.35065 5.35189 1.64904 9.90168 1.64904C14.4515 1.64904 18.1531 5.35065 18.1531 9.90044C18.1531 15.139 11.8721 22.2769 9.90168 24.3855Z",
    fill: "#0075BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90165 4.95117C7.17152 4.95117 4.95081 7.17189 4.95081 9.90201C4.95081 12.6321 7.17152 14.8529 9.90165 14.8529C12.6318 14.8529 14.8525 12.6321 14.8525 9.90201C14.8525 7.17189 12.6318 4.95117 9.90165 4.95117ZM9.90165 13.2026C8.08198 13.2026 6.60109 11.7217 6.60109 9.90201C6.60109 8.08235 8.08198 6.60145 9.90165 6.60145C11.7213 6.60145 13.2022 8.0811 13.2022 9.90201C13.2022 11.7229 11.7213 13.2026 9.90165 13.2026Z",
    fill: "#0075BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/Ubicacion.1bb2b67d20bbc54e88e6e37c94ffc88f.svg";
export { ForwardRef as ReactComponent };